import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { fetch } from '@ngrx/router-store/data-persistence';
import { ProfileApiService } from '@fantaz/shared/data-access/api';

import * as InvitationsActions from './invitations.actions';
import { catchError, map, mergeMap, of } from 'rxjs';

@Injectable()
export class InvitationsEffects {
  init$ = createEffect(() =>
    this.actions$.pipe(
      ofType(InvitationsActions.init),
      mergeMap(() =>
        this.profileApiService
          .fetchAllInvitations()
          .pipe(map((data) => InvitationsActions.loadInvitationsSuccess(data))),
      ),
      catchError((error) => {
        console.error('Error', error);
        return of(InvitationsActions.loadInvitationsFailure({ error }));
      }),
    ),
  );

  constructor(
    private readonly actions$: Actions,
    private readonly profileApiService: ProfileApiService,
  ) {}
}
